<template>
  <GAlert
    border
    variant="warning"
    :show-icon="false"
  >
    <GBox
      flex
      align="center"
      class="alert-wrapper"
    >
      <GIcon
        name="alert-triangle"
        stroke="var(--orange-500)"
        fill="var(--white)"
        size="24px"
      />
      <ul class="text-list">
        <li
          :key="'text-'+idx"
          v-for="(text, idx) in texts"
        >
          <GText>
            {{ text }}
          </GText>
        </li>
      </ul>
    </GBox>
  </GAlert>
</template>

<script>

import GBox from '@trendyol-js/grace/core/GBox';
import GText from '@trendyol-js/grace/core/GText';
import GAlert from '@trendyol-js/grace/core/GAlert';
import GIcon from '@trendyol-js/grace/core/GIcon';

export default {
  name: 'Alert',
  components: {
    GBox,
    GText,
    GAlert,
    GIcon,
  },
  props: {
    texts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-wrapper{
  ::v-deep {
    svg{
      min-width: 24px;
      min-height: 24px;
    }
  }
  .text-list{
    list-style: unset;
    margin-left: 24px;
    li{
      &::marker{
        color: #273142;
      }
    }
  }
}
</style>
